import { combineReducers } from 'redux';
import ReducerRegisterTime from './reducer-register-time';
import ReducerTimer from './reducer-timer';
import ReducerRegisterInfo from './reducer-register-info'

export const allReducers = combineReducers({
  	reducerRegisterTime: ReducerRegisterTime,
	reducerTimer: ReducerTimer,
	reducerRegisterInfo: ReducerRegisterInfo
});

export default allReducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js